(()=>{
 const header=document.querySelector('.header-section')||document.querySelector('#SiteHeader');
 let frame;
 const sync=()=>{
  frame=null;
  const source=header?.querySelector('.Vtl-WishlistHeader__HeartCounter');
  if(!source)return;
  const match=source.textContent.trim().match(/^\d+$/);
  if(!match)return;
  const count=Number(match[0]);
  document.querySelectorAll('[data-anu-wishlist-count]').forEach(badge=>{
   const text=String(count);
   if(badge.textContent!==text)badge.textContent=text;
   if(badge.hidden!==(count===0))badge.hidden=count===0;
  });
 };
 const isCounter=node=>node.nodeType===1&&(node.matches('.Vtl-WishlistHeader__HeartCounter')||node.querySelector('.Vtl-WishlistHeader__HeartCounter'));
 const observer=header?new MutationObserver(records=>{
  const changed=records.some(record=>record.target.parentElement?.closest('.Vtl-WishlistHeader__HeartCounter')||record.target.matches?.('.Vtl-WishlistHeader__HeartCounter')||[...record.addedNodes,...record.removedNodes].some(isCounter));
  if(changed&&!frame)frame=requestAnimationFrame(sync);
 }):null;
 observer?.observe(header,{childList:true,subtree:true,characterData:true});
 sync();
 const shell=document.querySelector('[data-anu-wishlist-loading]');
 const timeout=shell?setTimeout(()=>{
  if(document.querySelector('.Vtl-WishlistPage__Title'))return;
  shell.querySelector('[data-wishlist-status]').textContent=shell.dataset.slow;
  shell.querySelector('[data-wishlist-retry]').hidden=false;
 },12000):null;
 window.addEventListener('pagehide',()=>{observer?.disconnect();if(frame)cancelAnimationFrame(frame);if(timeout)clearTimeout(timeout)});
 window.addEventListener('pageshow',event=>{if(event.persisted){observer?.observe(header,{childList:true,subtree:true,characterData:true});sync()}});
})();


